<template>
  <div class="page">
    <div class="container" style="position: relative;">
      <div class="banner-area banner-wrapper" v-if="projectData.picture && projectData.picture.length">
        <swiper ref="mySwiper" class="banner-list" :options="swiperOption">
          <swiper-slide class="banner-item" v-for="(item,index) in projectData.picture" :key="index">
            <template v-if="projectData.filter_id[index]==0">
              <img :src="hostUrl + item" class="cover-img" mode="aspectFill">
            </template>
            <template v-else>
              <img :src="hostUrl + item" class="cover-img" mode="aspectFill">
              <img src="~@static/ugc/creation/filter/mask-1.png" class="filter-mask" mode="aspectFill">
              <img src="~@static/ugc/creation/filter/top-1.png" class="filter-top" mode="widthFix">
              <img src="~@static/ugc/creation/filter/bottom-1.png" class="filter-bottom" mode="widthFix">
            </template>
          </swiper-slide>
        </swiper>
        <div class="thunmbs">
          <div class="thunmbs-wrapper" :class="{current: swiperCurrent == index}" v-for="(item,index) in projectData.picture" :key="index" @click="changeBannr" :data-index="index">
            <template v-if="projectData.filter_id[index]==0">
              <img :src="hostUrl + item" class="cover-img" mode="aspectFill">
            </template>
            <template v-else>
              <img :src="hostUrl + item" class="cover-img" mode="aspectFill">
              <img src="~@static/ugc/creation/filter/mask-1.png" class="filter-mask" mode="aspectFill">
              <img src="~@static/ugc/creation/filter/top-1.png" class="filter-top" mode="widthFix">
              <img src="~@static/ugc/creation/filter/bottom-1.png" class="filter-bottom" mode="widthFix">
            </template>
          </div>
        </div>
        <div class="status-bar">
          <img src="~@static/fundingnew/profile/gallery/icon-not-pass.png" class="cover-img" v-if="projectData.status==2">
          <img src="~@static/fundingnew/profile/gallery/icon-pass.png" class="cover-img" v-if="projectData.status==1">
          <img src="~@static/fundingnew/profile/gallery/icon-review.png" class="cover-img" v-if="projectData.status==0">
        </div>
      </div>

      <div class="project-wrapper">
        <div class="flex-row justify-between">
          <div class="project-author">
            <img :src="projectData.headimgurl" /> {{projectData.nickname}}
          </div>

          <div class="liked-status">
            <div class="liked-statistics">
              <div class="liked-operation">
                <div class="like-num">{{projectData.like_count}}</div>

                <button class="button operation-item" v-if="noLogin" @click="toLogin">
                  <div class="btn-inner">
                    <img src="~@static/ugc/list/icon-un-like.png" />
                  </div>
                </button>

                <button v-else class="button operation-item">
                  <!-- :class="{active: projectData.voted == '1'}" -->
                  <div class="btn-inner">
                    <img v-if="projectData.voted == '1'" src="~@static/ugc/list/icon-like.png" />
                    <img v-if="projectData.voted != '1'" src="~@static/ugc/list/icon-un-like.png" />
                    <!-- mode="widthFix" -->
                  </div>
                </button>
              </div>

              <div class="like-users">
                <img :src="item==''?require('@static/fundingnew/register/avatar-default.png'): item" v-for="(item,index) in projectData.like_users" :key="index" />
              </div>

            </div>
          </div>
        </div>

        <div class="plan-title-wrapper">
          <div>{{projectData.name}}</div>
          <div class="location-wrapper" v-if="projectData.distance > 0">
            <img mode="widthFix" src="~@static/ugc/list/icon-spot.png" />{{(projectData.distance / 1000).toFixed(1)}}KM
          </div>
        </div>

        <div class="gallery-title">{{projectData.title}}</div>
        <div class="gallery-desc">{{projectData.description}}</div>

        <div class="comments-container">
          <template v-if="commentsData.length">
            <div class="comments-title">精彩评论</div>
            <div class="comments-list">
              <div v-for="(item,index) in commentsData" :key="index" class="comment-list-item">
                <div class="avatar-container">
                  <img :src="item.headimgurl" />
                  <!-- mode="widthFix" -->
                </div>
                <div class="comment-list-item-wrapper">
                  <div class="user-bar">
                    <div class="name">{{item.nickname}}</div>
                    <div class="data-time">{{item.formatTime.year}}.{{item.formatTime.month}}.{{item.formatTime.day}} {{item.formatTime.hours}}:{{item.formatTime.minutes}}</div>
                  </div>
                  <div class="comment-content">{{item.comment}}</div>
                </div>
              </div>
            </div>
            <load-more-btn v-if="hasMoreComments" text="查看全部评论+" @loadMore="loadMoreComments"></load-more-btn>
          </template>
        </div>
      </div>

      <div class="delUgc" @click="fnDelUgc">
        <img src="~@static/fundingnew/profile/gallery/btn-delete.png" alt="">
      </div>

      <div class="pop" v-if="isShowDelPop">
        <!-- <div class="mask"></div> -->
        <div class="pop-inner">
          <div class="pop-title">
            <img src="~@static/fundingnew/profile/gallery/pop-text.png">
          </div>
          <div class="btns">
            <img src="~@static/fundingnew/profile/gallery/btn-cancel.png" class="btn-cancel" @click="bindToCancel">
            <img src="~@static/fundingnew/profile/gallery/btn-confirm.png" class="btn-confirm" @click="bindToDelete">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadMoreBtn from '@components/LoadMoreBtn'
import { mapState } from 'vuex'
import { verify, tools } from '@/utils'
import { behavior } from '@/utils/behavior'
const geolocation = new qq.maps.Geolocation()

let vm
export default {
  name: '',
  components: {
    LoadMoreBtn,
  },
  data() {
    vm = this
    return {
      hostUrl: this.$apiConfig.host,
      uploadUrl: this.$apiConfig.uploadUrl,
      projectId: '',
      projectData: {},
      comment: '',
      commentsPage: 1,
      commentsPerPage: 10,
      commentsData: [],
      canComment: true,
      hasMoreComments: true,
      filterParam: {},
      canLoad: true,
      lat: 0,
      lng: 0,
      swiperCurrent: 0,
      swiperOption: {
        //循环
        loop: true,
        initialSlide: 0,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        //自动播放
        autoplay: {
          delay: 22500,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        //滑动速度
        speed: 500,
        //滑动方向
        direction: 'horizontal',
        on: {
          slideChangeTransitionEnd: function () {
            vm.swiperCurrent = this.realIndex //loop模式下真实索引
          },
        },
        preventLinksPropagation: false,
      },
      isShowDelPop: false,
    }
  },
  computed: {
    ...mapState(['authorization']),
    noLogin() {
      return !this.authorization || this.authorization == ''
    },
    swiper() {
      return this.$refs.mySwiper.swiper
    },
  },
  async created() {
    this.projectId = this.$route.params.id
    this.filterParam = {
      page: this.commentsPage,
      'per-page': this.commentsPerPage,
    }
    geolocation.getLocation(
      pos => {
        this.lat = pos.lat
        this.lng = pos.lng
        this.requestProjectDetail()
        this.requestComments()
      },
      fail => {
        this.requestProjectDetail()
        this.requestComments()
        if (fail.code === 1) {
          console.log('拒绝定位权限')
        }
      },
    )
  },
  mounted() { },
  methods: {
    changeBannr(e) {
      let { index } = e.currentTarget.dataset
      this.swiper.slideTo(Number(index) + 1, 500, false)
    },
    requestProjectDetail(type) {
      this.$request
        .get(`${this.$apiConfig.myUgc}/${this.projectId}`, {
          params: {
            lat: this.lat,
            lng: this.lng,
          },
        })
        .then(res => {
          let resData = res.data
          if (resData.code === 0 && resData.data) {
            const _resData = resData.data
            if (type == 'like_user') {
              this.projectData.like_users = _resData.like_users
              return
            }
            if (_resData.distance > 0) {
              _resData.distance = (_resData.distance / 1000).toFixed(1)
            }

            this.projectData = _resData

            // 分享
            if (verify.isWeixin()) {
              let shareInfo = {
                title: '绝对夜计划',
                desc: '绝对赛博夜计划，最高赢取5万元派对金，邀你一起造',
                imgUrl: this.$apiConfig.domain + '/static/funding_cpunk/share.png?v=1',
              }
              let p = tools.parseParams(this.$route.query)
              this.WXConfig.wxShowMenu(`${this.$apiConfig.domain}/welcome?${p}`, shareInfo)
            }
          }
        })
    },
    requestComments() {
      this.$request
        .get(`${this.$apiConfig.myUgcCommentUrl}/${this.projectId}`, {
          params: this.filterParam,
        })
        .then(res => {
          let resData = res.data
          if (resData.code === 0) {
            const _resData = resData.data
            let _totalPage = _resData._meta.pageCount

            if (this.filterParam.page == 1) {
              this.commentsData = []
              this.commentsPage = 1
            }
            if (!!_resData.items && _resData.items.length > 0) {
              _resData.items.forEach(item => {
                item.formatTime = tools.formatDate(item.created_at)
                if (item.headimgurl == '') {
                  item.headimgurl = require('@static/fundingnew/register/avatar-default.png')
                }
              })
              this.commentsData = this.commentsData.concat(_resData.items)
              if (this.commentsPage == _totalPage) {
                this.hasMoreComments = false
              } else {
                if (_resData.items.length < this.commentsPerPage) {
                  this.hasMoreComments = false
                } else {
                  this.commentsPage += 1
                  this.filterParam.page = this.commentsPage
                  this.hasMoreComments = true
                }
              }
              this.canLoad = true
            } else {
              this.hasMoreComments = false
            }
          } else {
            console.log(res.msg)
          }
        })
    },
    loadMoreComments() {
      if (this.hasMoreComments && this.canLoad) {
        this.canLoad = false
        this.requestComments()
      }
    },
    toLogin() {
      this.$router.push(`/login?redirect=${encodeURIComponent(this.$route.fullPath)}`)
    },
    fnDelUgc() {
      this.isShowDelPop = true
      _jcq.push(['_track', 'ugc_delete'])
      behavior({ behavior_code: 'prc_bhv_abs_personalcenter_bc7' })
    },
    bindToCancel() {
      this.isShowDelPop = false
    },
    bindToDelete() {
      let _this = this
      this.$request.post(this.$apiConfig.delMyUgc + '/' + this.projectId).then(res => {
        this.isShowDelPop = false
        _this.$router.go(-1)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.banner-wrapper /deep/ .swiper-pagination {
  bottom: pxtow(20);
}
.banner-wrapper /deep/ .swiper-pagination-bullet {
  width: pxtow(8);
  height: pxtow(8);
  margin: 0 pxtow(3);
  border-radius: pxtow(4);
  background-color: nth($white, 1);
  overflow: hidden;
  opacity: 0.5;
}
.banner-wrapper /deep/ .swiper-pagination-bullet-active {
  background-color: nth($white, 1);
  opacity: 1;
}

.container {
  font-family: 'SourceHanSansCN-Normal';
}
.banner-area {
  width: 100%;
  height: pxtow(1000);
  position: relative;
}
.banner-list {
  width: 100%;
  height: 100%;
}
.banner-list .cover-img {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: cover;
}
.flex-row {
  display: flex;
}
.justify-between {
  justify-content: space-between;
}
.project-wrapper {
  padding: pxtow(30) pxtow(60);
}
.project-author img {
  width: pxtow(90);
  height: pxtow(90);
  border: 1px solid #fff;
  border-radius: 100%;
  margin-right: pxtow(10);
}
.liked-status {
  margin-top: pxtow(18);
}
.liked-status .operation-item img {
  width: pxtow(34);
  height: auto;
}
.liked-status button {
  display: inline-block;
  padding: 0;
  border: none;
  background-color: transparent;
  margin-left: 0;
  font-size: inherit;
}
.liked-operation,
.liked-statistics {
  display: flex;
}
.liked-operation {
  margin-right: pxtow(20);
}
.like-num {
  color: #ef2ac1;
  margin-right: pxtow(10);
  margin-top: pxtow(8);
}
.like-users img {
  width: pxtow(34);
  height: pxtow(34);
  border-radius: 100%;
  border: 1px solid #fff;
  margin-left: pxtow(-5);
}
.plan-title-wrapper {
  display: flex;
  font-size: pxtow(22);
  padding: pxtow(20) 0;
}

.plan-title-wrapper .location-wrapper {
  padding-left: pxtow(15);
}
.plan-title-wrapper img {
  width: pxtow(18);
  height: auto;
  // padding: 0 pxtow(10);
  margin-right: pxtow(10);
  vertical-align: pxtow(-2);
}
.gallery-title {
  font-size: pxtow(36);
  padding: 0 0 pxtow(20) 0;
}
.gallery-desc {
  font-size: pxtow(22);
  padding: 0 0 pxtow(20) 0;
  line-height: 120%;
}

.comments-container {
  padding: pxtow(40) 0;
  font-weight: 500;
  font-size: pxtow(30);
  color: rgba(255, 255, 255, 0.75);
}

.comments-title {
  display: inline;
  font-weight: 900;
  font-size: pxtow(45);
  text-align: left;
  color: #fff;
  position: relative;
  z-index: 2;
}
.comments-title::before {
  content: '';
  width: 120%;
  height: pxtow(20);
  background: linear-gradient(to right, #dc2dbf, #2f32a7);
  position: absolute;
  bottom: pxtow(-2);
  left: 50%;
  transform: translate(-50%);
  border-radius: pxtow(10);
  z-index: -1;
}

.nologin-tips {
  padding: pxtow(32);
  text-align: center;
}

.nologin-tips .tips {
  margin-bottom: pxtow(12);
  font-size: pxtow(30);
  color: #fff;
}

.nologin-tips .login-btn {
  width: pxtow(170);
  // height: pxtow(56);
  display: inline-block;
  background: transparent;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url('~@static/ugc/list/border-gradient-s.png');
  padding: 0;
}

.nologin-tips .login-btn .btn-inner {
  color: #fff;
  height: pxtow(56);
  font-size: pxtow(24);
  line-height: pxtow(56);
}

.comment-submit {
  /* display: flex; */
  padding: pxtow(50) 0 0;
  align-items: center;
}

.comment-submit .input-area {
  position: relative;
  flex: 1;
  font-size: pxtow(26);
}
.comment-submit .input-area textarea {
  width: auto;
  height: pxtow(180);
  background: linear-gradient(to right, rgba(220, 45, 191, 0.5), rgba(47, 50, 167, 0.5));
}

.comment-submit .input-area .form-control {
  width: 100%;
  border: 0;
  outline: none;
  padding: pxtow(30);
  border-radius: pxtow(20);
  background-size: 100% 100%;
  &::placeholder {
    color: #fff;
  }
}

.comment-submit .submit-btn {
  width: pxtow(170);
  // height: pxtow(56);
  display: inline-block;
  background: transparent;
  background-repeat: no-repeat;
  background-size: contain;
  color: #fff;
  position: relative;
  left: 50%;
  transform: translate(-50%);
  z-index: 2;
  margin-top: pxtow(40);
  padding: 0;
  background-image: url('~@static/ugc/list/border-gradient-s.png');
}
.comment-submit .submit-btn:after {
  border: 0;
}
.comment-submit .submit-btn .btn-inner {
  color: #fff;
  height: pxtow(56);
  font-size: pxtow(24);
  line-height: pxtow(56);
}

.comments-list {
  padding: pxtow(30) 0;
}

.comment-list-item {
  padding: pxtow(30) 0;
  display: flex;
}
.comment-list-item-wrapper {
  flex: 1;
}
.comment-list-item .avatar-container {
  width: pxtow(80);
  height: pxtow(80);
  position: relative;
  margin-right: 15px;
  z-index: 2;
}

.comment-list-item .avatar-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: pxtow(40);
  border: 1px solid #fff;
}

.comment-list-item .user-bar {
  display: flex;
  margin-bottom: pxtow(20);
  align-items: center;
}

.comment-list-item .user-bar .name {
  flex: 1;
  font-size: pxtow(22);
  color: #fff;
}

.comment-list-item .user-bar .data-time {
  font-size: pxtow(22);
  text-align: right;
  color: rgba(255, 255, 255, 1);
  font-family: Arial, Helvetica, sans-serif;
}

.comment-list-item .comment-content {
  font-size: pxtow(22);
  font-family: Arial, Helvetica, sans-serif;
  color: #fff;
}

.load-more-btn {
  color: #ef2ac1;
  background: transparent;
  font-size: pxtow(22);
  margin: pxtow(20) auto 0;
}
.status-bar {
  position: absolute;
  right: (20/7.5) * 1vw;
  top: (20/7.5) * 1vw;
  z-index: 2;
  img {
    height: pxtow(35);
  }
}
.delUgc {
  width: (258/7.5) * 1vw;
  margin: -20px auto 0;
  img {
    width: 100%;
  }
}

.pop {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 9;
}
.pop .mask {
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
}
.pop-inner {
  width: (550/7.5) * 1vw;
  height: (250/7.5) * 1vw;
  background: #fff;
  border-radius: (10/7.5) * 1vw;
  padding: (60/7.5) * 1vw 0 0;
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.pop-title img {
  width: (233/7.5) * 1vw;
  height: auto;
  display: block;
  margin: 0 auto;
}
.pop .btns {
  display: flex;
  justify-content: center;
  margin-top: (30/7.5) * 1vw;
}
.pop .btns img {
  width: auto;
  height: (54/7.5) * 1vw;
  display: block;
  margin: 0 (5/7.5) * 1vw;
}

.thunmbs {
  width: 100%;
  padding: pxtow(10);
  box-sizing: border-box;
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: start;
  z-index: 2;
}
.thunmbs .cover-img.current {
  opacity: 1;
}
.thunmbs .thunmbs-wrapper {
  position: relative;
  width: pxtow(120);
  height: pxtow(120);
  margin-right: pxtow(10);
  border-radius: pxtow(10);
  opacity: 0.8;
  overflow: hidden;
}
.thunmbs .thunmbs-wrapper.current {
  opacity: 1;
}
.thunmbs .cover-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.filter-mask {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
.filter-top {
  position: absolute;
  width: 100%;
  height: auto;
  left: 0;
  top: 0;
}
.filter-bottom {
  position: absolute;
  width: 100%;
  height: auto;
  left: 0;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/fundingnew/my/gallery/detail.vue